<app-lb-floating-ip></app-lb-floating-ip>
